const ONE_SECOND_MS = 1000;
export const THIRTY_SECONDS_MS = 30 * ONE_SECOND_MS;
export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
export const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS;
export const FIFTY_MINUTES_MS = 50 * ONE_MINUTE_MS;

// Placeholder until the contractor's zone derives from ServiceArea data (ODD-10924).
export const CONTRACTOR_TIME_ZONE = "America/Los_Angeles";
